module.exports = __webpack_public_path__ + "img/rq-banner@2x.b522d22e.png";